import { Controller } from "@hotwired/stimulus"

// data-controller="sources" — guard de FR22 no cliente: nao deixa desmarcar a ultima fonte
// (o servidor tambem recusa lista vazia). Targets: checkbox (as 4 fontes), aviso.
export default class extends Controller {
  static targets = ["checkbox", "aviso"]

  changed(event) {
    const marcados = this.checkboxTargets.filter((c) => c.checked)
    if (marcados.length === 0) {
      event.target.checked = true // reverte a desmarcação da última
      this.avisoTarget?.classList.remove("hidden")
    } else {
      this.avisoTarget?.classList.add("hidden")
    }
  }
}
